/** 検索種別 */
export type SEARCH_TYPE = (typeof SEARCH_TYPE)[keyof typeof SEARCH_TYPE];
export const SEARCH_TYPE = {
  UNDEFINED: '',
  E_TICKET_BY_DEPARTURE_DATE: 'eTicketByDepartureDate',
  E_TICKET_BY_PURCHASE_DATE: 'eTicketByPurchaseDate',
  EMD_BY_AMC_NUMBER: 'emdByAmcNumber',
  E_TICKET_AND_EMD_BY_PNR_FOR_RECEIPT: 'eTicketAndEmdByPnrForReceipt',
} as const;
